import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/NoAuth/Wxlogin.vue'),

    // redirect: '/admin/login'
  },
  {
    path: '/admin/login',
    name: 'login',
    component: () => import('@/views/NoAuth/Login.vue')
  },
  {
    path: '/wxlogin',
    name: 'wxlogin',
    component: () => import('@/views/NoAuth/Wxlogin.vue'),
    meta: {
      name: '微信登陆'
    }
  },
  {
    path: '/meeting',
    name: 'meeting',
    component: () => import('@/views/NoAuth/Meeting.vue'),
    meta: {
      name: '微信登陆'
    }
  },
  {
    path: '/meetinglink',
    name: 'meetinglink',
    component: () => import('@/views/NoAuth/Meetinglink.vue'),
    meta: {
      name: '微信登陆'
    }
  },
  {
    path: '/UserAuthentication',
    name: 'UserAuthentication',
    component: () => import('@/views/NoAuth/UserAuthentication.vue'),
    meta: {
      name: 'UserAuthentication'
    }
  },
  {
    path: '/auth',
    component: () => import('@/views/Auth/Auth.vue'),
    children: [{
        path: '/auth/Index',
        name: 'Index',
        component: () => import('@/modules/Index/Index.vue'),
      },
      {
        path: '/auth/Manage',
        name: 'Manage',
        component: () => import('@/modules/Manage/Manage.vue'),
      },
      {
        path: '/auth/NewMeeting',
        name: 'NewMeeting',
        component: () => import('@/modules/Index/NewMeeting.vue'),
      },
    ]
  },
  {
    path: '/admin/sign',
    component: () => import('@/views/Auth/Auth.vue'),
    children: [
      {
        path: 'IndexSignIn',
        name: 'IndexSignIn',
        component: () => import('@/modules/IndexSignIn/IndexSignIn.vue'),
      },
      {
        path: 'ManageSignIn',
        name: 'ManageSignIn',
        component: () => import('@/modules/Manage/ManageSignIn.vue'),
      },
      {
        path: 'NewMeetingSignIn',
        name: 'NewMeetingSignIn',
        component: () => import('@/modules/IndexSignIn/NewMeetingSignIn.vue'),
      },
    ]
  }
]
const router = new VueRouter({
  mode: 'history',
  routes
})


router.beforeEach((to, from, next) => {
  let isLogin = localStorage.getItem('token');
  if (isLogin) {
    // 如果存在token 放行
    next()
  } else {
    //如果用户token不存在且 当前页面就是 则放行
    if (to.path === '/admin/login' || to.path === '/wxlogin' || to.path == '/UserAuthentication' || to.path == '/meeting' || to.path == '/' || to.path == '/meetinglink') {
      next()
    } else {
      // 当前页面不是登录页 则直接跳转到页面
      next('/admin/login')
    }
  }
})

export default router